import React, { useRef, useState, useEffect } from "react";

import { Table, TableBody, TableContainer, TableHead, TableRow,
  TextField, Paper, Button, Checkbox, InputAdornment,
  Divider, Menu, MenuItem, TableSortLabel, Snackbar, IconButton
} from "@mui/material";

import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import SearchIcon from "@mui/icons-material/Search";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import RestoreIcon from "@mui/icons-material/Restore";
import CachedIcon from "@mui/icons-material/Cached";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloseIcon from "@mui/icons-material/Close";

import DialogLicense from "../components/adminsuite/DialogLicense.js";
import DialogViewLicense from "../components/adminsuite/DialogViewLicense.js";
import DialogMainLicense from "../components/adminsuite/DialogMainLicense.js";

import {
  AddButton, StyledTableRow,
  StyledTableCell, InputStyle,
  CheckBox, StyleTableSortLabel
} from "../SXStyle";

//loaders
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { obtenerListadoLicencias } from "../service/apiService.js";
import { useAppDispatch, useAppSelector } from "../provider/app/hooks";
import { setItems as setLicensesItem  } from "../provider/Slice/LicenceSlice";
import { useNavigate } from "react-router-dom";

export default function LicensesAdminSuite() {

  //react-router-doom
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const licencias = useAppSelector((state) => state.StoreLicencias.data);
  

  const [buscador, setBuscador] = useState("");
  const [data, setData] = useState([]);

  //states del main menu
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  // Estado global para el menú
  const [rowAnchorEl, setRowAnchorEl] = useState(null);
  const [menuRowId, setMenuRowId] = useState(null);

  const [registro, setRegistro] = useState();

  const [columnasVisibles, setColumnasVisibles] = useState({
    name: true,
    entitlement: true,
    type: true,
    model: true,
    state: true,
    seats_total: true,
    seats_reserved: true,
    valid_from: true,
    valid_until: true
  });

  //order columns
  const [order, setOrder] = useState("asc");            // "asc" o "desc"
  const [orderBy, setOrderBy] = useState("type");       // columna ordenada

  //dialog
  const [openDialog, setOpenDialog] = useState();
  const [openViewDialog, setOpenViewDialog] = useState();
  const [openMainDialog, setOpenMainDialog] = useState();

  //loader
  const [openLoader, setOpenLoader] = useState(true);

  //snackbar de alertas
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
  });


  //cierra el snackbar
  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };
  
  const abrirMenuColumnas = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //functions del menu table
  const abrirTableMenu = (event, rowId) => {
    setRowAnchorEl(event.currentTarget);
    setMenuRowId(rowId);
  };

  const cerrarTableMenu = () => {
    setRowAnchorEl(null);
    setMenuRowId(null);
  };

  const abrirEditarRegistro = (row) => {
    setRegistro(row);
    setRowAnchorEl(null);
    setMenuRowId(null);
    setOpenDialog(true);
  }

  const verLicencias = (row) => {
    console.log({row})
    setRegistro(row);
    setRowAnchorEl(null);
    setMenuRowId(null);
    setOpenViewDialog(true);
  }

  const asignarLicencias = (row) => {
    console.log({row})
    setRegistro(row);
    setRowAnchorEl(null);
    setMenuRowId(null);
    setOpenMainDialog(true);
  }

  const abrirCrearNuevoRegistro = () => {
    setRegistro(null);
    setOpenDialog(true);
  }

  const isMenuTableAbierto = (rowId) => {
    return menuRowId === rowId;
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const sortedData = React.useMemo(
    () => [...data || []].sort(getComparator(order, orderBy)),
    [data, order, orderBy]
  );


  // aplica el filtrado
  useEffect(() => {

    setOpenLoader(true);

    // Activa un loader primero
    setTimeout(() => {
      const resultados = licencias?.filter((item) => {
        const valores = Object.values(item);
        return valores.some((valor) => {
          if (typeof valor === "string" || typeof valor === "number") {
            return valor.toString().toLowerCase().includes(buscador);
          }
          return false;
        });
      });

      setData(resultados);
      setOpenLoader(false);
    }, 300);

  }, [buscador]);

  
  //recarga el listado al sufrir un cambio
  useEffect(() => {
    setOpenLoader(true);
  
    // Activa un loader primero
    setTimeout(() => {
      setData(licencias);
      setOpenLoader(false);
    }, 300);

  }, [licencias]);


  const habilitarVisibilidadColumnas = (checked, column) => {
    setColumnasVisibles((prev) => ({
      ...prev,
      [column]: checked,
    }));
  };

  const resetTable = () => {
    setColumnasVisibles({
      name: true,
      entitlement: true,
      type: true,
      model: true,
      state: true,
      seats_total: true,
      seats_reserved: true,
      valid_from: true,
      valid_until: true
    });
    setBuscador("");
  };

  //action snackbar
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleSnackClose}
      >
        <CloseIcon fontSize="small" className="text-amarillo" />
      </IconButton>
    </React.Fragment>
  );

  const getTogleColumn = (name) => {
    switch (name) {
      case 'state':
        return "Estado"
      case 'name':
        return "Nombre"
      case 'entitlement':
        return "Permiso"
      case 'type':
        return "Tipo"
      case 'model':
        return "Modelo"
      case 'seats_total':
        return "Asientos Totales"
      case 'seats_total':
        return "Asientos Totales"
      case 'seats_reserved':
        return "Asientos Reservados"
      case 'valid_from':
        return "Válido desde"
      case 'valid_until':
        return "Válido hasta"
    }
  }

  const cargarListadoLicencias = async () => {
    try {
      setOpenLoader(true);
      const result = await obtenerListadoLicencias();
      dispatch(setLicensesItem(result.data));
    } catch (error) 
    {
      console.log({ error });
    } finally {
      setOpenLoader(false);
    }
  };

  return (
    <section className="bg-fondo_blanco shadow-xl rounded-lg">
      <div className="flex flex-col h-[82vh] px-12 py-8 mx-auto ">
        <div className="bg-ceniza_light border border-gray-600 rounded-lg shadow-xl p-5 ml-5 h-[75vh] w-full">
          
          {/* Dialog */}
          <DialogLicense 
            open={openDialog}
            setOpen={setOpenDialog}
            registro={registro}
            setSnackbar={setSnackbar}
          />

          {/* View Dialog */}
          <DialogViewLicense 
            open={openViewDialog}
            setOpen={setOpenViewDialog}
            registro={registro}
            setSnackbar={setSnackbar}
          />

          {/* Para usar una licencia  */}
          <DialogMainLicense
            open={openMainDialog}
            setOpen={setOpenMainDialog}
            registro={registro}
            setSnackbar={setSnackbar}
          />

        
          {/* Snackbar */}
          <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleSnackClose}
            message={snackbar.message}
            action={action}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            ContentProps={{
            sx: {
              color: "#fffcfc"
            },
            }}
          />

          {/* Loader */}
          <Backdrop
            sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
            open={openLoader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          {/* Accesos Rapidos */}
          <div className="flex justify-end  mt-6 gap-2">
           
            <TextField
              id="buscar"
              label="Buscar"
              size="small"
              value={buscador}
              defaultValue=""
              className="rounded-lg block w-full bg-inputs border"
              sx={{
                ...InputStyle,
                width: "320px",
                height: "40px",
                marginTop: "12px",
              }}
              onChange={(e) => setBuscador(e.target.value)}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon className="text-amarillo" fontSize="10" />
                    </InputAdornment>
                  ),
                },
              }}
            />

            {/* Menu de Visibilidad de Columnas */}
            <div>
              <div
                className="border border-gris rounded-md inline-block p-1 h-[40px] mt-[13px] cursor-pointer"
                id="basic-button"
                aria-controls={isMenuOpen ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={isMenuOpen ? "true" : undefined}
                onClick={(e) => abrirMenuColumnas(e)}
              >
                <ViewWeekIcon className="text-amarillo" fontSize="medium" />
              </div>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={isMenuOpen}
                onClose={() => setAnchorEl(null)}
                sx={{ width: "100%", padding: "5px" }}
                slotProps={{
                  list: {
                    "aria-labelledby": "basic-button",
                  },
                }}
              >
                <p className="w-[160px] text-center"> Alternar columnas </p>
                <Divider />

                {Object.entries(columnasVisibles).map(([name, value]) => (
                  <div className="flex">
                    <Checkbox
                      checked={value}
                      name={name}
                      sx={CheckBox}
                      onChange={(e) =>
                        habilitarVisibilidadColumnas(e.target.checked, name)
                      }
                    />
                    <MenuItem style={{ pointerEvents: "none" }}>
                      {getTogleColumn(name)}
                    </MenuItem>
                  </div>
                ))}
              </Menu>
            </div>

            <div
              className="border border-gris rounded-md inline-block p-1 h-[40px] mt-[13px] cursor-pointer"
              onClick={resetTable}
            >
              <RestoreIcon className="text-amarillo" fontSize="medium" />
            </div>

            <div
              className="border border-gris rounded-md inline-block p-1 h-[40px] mt-[13px] cursor-pointer"
              onClick={() => cargarListadoLicencias()}
            >
              <CachedIcon className="text-amarillo" fontSize="medium" />
            </div>
          </div>

          {/* Tabla */}
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "350px", width: "100%", marginTop: "20px" }}
          >
            <Table aria-label="customized table" stickyHeader>
              <TableHead>
                <TableRow>

                  {columnasVisibles.state && (
                    <StyledTableCell 
                      align="center" 
                      sortDirection={orderBy === 'state' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'state'}
                        direction={orderBy === 'state' ? order : 'asc'}
                        onClick={() => handleRequestSort('state')}
                        sx={StyleTableSortLabel}
                      >
                        Estado
                      </TableSortLabel>
                    </StyledTableCell>
                  )}
                  
                  {columnasVisibles.name && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'name' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'name'}
                        direction={orderBy === 'name' ? order : 'asc'}
                        onClick={() => handleRequestSort('name')}
                        sx={StyleTableSortLabel}
                      >
                        Nombre
                      </TableSortLabel>
                    </StyledTableCell>
                  )}

                  {columnasVisibles.entitlement && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'entitlement' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'entitlement'}
                        direction={orderBy === 'entitlement' ? order : 'asc'}
                        onClick={() => handleRequestSort('entitlement')}
                        sx={StyleTableSortLabel}
                      >
                        Permiso
                      </TableSortLabel>
                    </StyledTableCell>
                  )}

                  {columnasVisibles.type && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'type' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'type'}
                        direction={orderBy === 'type' ? order : 'asc'}
                        onClick={() => handleRequestSort('type')}
                        sx={StyleTableSortLabel}
                      >
                        Tipo
                      </TableSortLabel>
                    </StyledTableCell>
                  )}

                  {columnasVisibles.model && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'model' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'model'}
                        direction={orderBy === 'model' ? order : 'asc'}
                        onClick={() => handleRequestSort('model')}
                        sx={StyleTableSortLabel}
                      >
                        Modelo
                      </TableSortLabel>
                    </StyledTableCell>
                  )}

                  {columnasVisibles.seats_total && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'seats_total' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'seats_total'}
                        direction={orderBy === 'seats_total' ? order : 'asc'}
                        onClick={() => handleRequestSort('seats_total')}
                        sx={StyleTableSortLabel}
                      >
                        Asientos Totales
                      </TableSortLabel>
                    </StyledTableCell>
                  )}

                  {columnasVisibles.seats_reserved && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'seats_reserved' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'seats_reserved'}
                        direction={orderBy === 'seats_reserved' ? order : 'asc'}
                        onClick={() => handleRequestSort('seats_reserved')}
                        sx={StyleTableSortLabel}
                      >
                        Asientos Reservados
                      </TableSortLabel>
                    </StyledTableCell>
                  )}

                  {columnasVisibles.valid_from && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'valid_from' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'valid_from'}
                        direction={orderBy === 'valid_from' ? order : 'asc'}
                        onClick={() => handleRequestSort('valid_from')}
                        sx={StyleTableSortLabel}
                      >
                        Válido desde
                      </TableSortLabel>
                    </StyledTableCell>
                  )}

                  {columnasVisibles.valid_until && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'valid_until' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'valid_until'}
                        direction={orderBy === 'valid_until' ? order : 'asc'}
                        onClick={() => handleRequestSort('valid_until')}
                        sx={StyleTableSortLabel}
                      >
                        Válido hasta
                      </TableSortLabel>
                    </StyledTableCell>
                  )}

                  <StyledTableCell align="center">
                    <SettingsApplicationsIcon
                      className="text-amarillo"
                      sx={{ fontSize: 30 }}
                    />
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedData.map((row, index) => (
                  <StyledTableRow key={index}>

                    {columnasVisibles.state && (
                      <StyledTableCell align="center">
                        <div className="flex justify-center items-center">
                          <RadioButtonCheckedIcon
                            className={
                              row.state == "1" 
                                ? "text-verde" : 
                                row.state == "2" ?  "text-amarillo" 
                                : "text-rojo"
                            }
                          />
                          <p className="ml-2 mt-1">{row.state === 1 ? "Valido" : row?.state === 2 ? "Invalido" : "Expirado"}</p>
                        </div>
                      </StyledTableCell>
                    )}
                   
                    {columnasVisibles.name && (
                      <StyledTableCell align="center">
                        {row.name}
                      </StyledTableCell>
                    )}

                    {columnasVisibles.entitlement && (
                      <StyledTableCell align="center">
                        {row.entitlement}
                      </StyledTableCell>
                    )}

                    {columnasVisibles.type && (
                      <StyledTableCell align="center">
                        <div className="flex justify-center items-center">
                          <p className="ml-2 mt-1"> {row.type === 1 ? "Seat" : "Concurrent" } </p>
                        </div>
                      </StyledTableCell>
                    )}

                    {columnasVisibles.model && (
                      <StyledTableCell align="center">
                        {row.model}
                      </StyledTableCell>
                    )}

                    {columnasVisibles.seats_total && (
                      <StyledTableCell align="center">
                        {row.seats_total}
                      </StyledTableCell>
                    )}

                    {columnasVisibles.seats_reserved && (
                      <StyledTableCell align="center">
                        {row.seats_reserved}
                      </StyledTableCell>
                    )}

                    {columnasVisibles.valid_from && (
                      <StyledTableCell align="center">
                        {row.valid_from}
                      </StyledTableCell>
                    )}

                    {columnasVisibles.valid_until && (
                      <StyledTableCell align="center">
                        {row.valid_until}
                      </StyledTableCell>
                    )}
                   
                    <StyledTableCell align="center">
                      <div>
                        <div
                          className="cursor-pointer"
                          aria-controls={
                            isMenuTableAbierto(row.id)
                              ? "basic-menu"
                              : undefined
                          }
                          aria-haspopup="true"
                          aria-expanded={
                            isMenuTableAbierto(row.id) ? "true" : undefined
                          }
                          onClick={(e) => abrirTableMenu(e, row.id)}
                        >
                          <MoreHorizIcon
                            className="text-gris"
                            sx={{ fontSize: 25 }}
                          />
                        </div>

                        <Menu
                          id="basic-menu"
                          anchorEl={rowAnchorEl}
                          open={isMenuTableAbierto(row.id)}
                          onClose={() => cerrarTableMenu()}
                          sx={{ width: "100%", padding: "5px" }}
                          slotProps={{
                            list: {
                              "aria-labelledby": "basic-button",
                            },
                          }}
                        >
                    
                          <MenuItem onClick={() => verLicencias(row)}>
                            Detalles
                          </MenuItem>

                          <MenuItem onClick={() => asignarLicencias(row)}>
                            Asginar licencia
                          </MenuItem>
                        </Menu>
                      </div>
                    </StyledTableCell>
                    
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>


        </div>
      </div>
    </section>
  );
}
